import { useMemo } from 'react';
import { cn } from '@divlab/divanui';

import SkeletRect from '@Skelets/SkeletRect';
import SkeletCrossaleProduct from '@Skelets/SkeletCrossaleProduct';
import SkeletWave from '@Skelets/SkeletWave';
import useMedias from '@Hooks/useMedias';
import styles from './SkeletPage.module.css';

import type { FC } from 'react';

export interface SkeletPageProps {
  className?: string;
  theme?: 'light' | 'gray';
}

const SkeletPage: FC<SkeletPageProps> = (props) => {
  const { className, theme = 'gray', ...restProps } = props;
  const { isMobile, isDesktop } = useMedias();

  const products = useMemo(() => {
    let count = 4;

    if (isDesktop) count = 3;
    if (isMobile) count = 1;

    return new Array(count).fill(1);
  }, [isDesktop, isMobile]);

  return (
    <div {...restProps} className={cn(styles.page, className)}>
      <div className={styles.head}>
        <SkeletRect className={styles.title} theme={theme}>
          Loading...
        </SkeletRect>
      </div>

      <div className={styles.body}>
        <div className={styles.content}>
          <SkeletRect className={styles.contentItem} theme={theme} />
          <SkeletRect className={styles.contentItem} theme={theme} />
          <SkeletRect className={styles.formItem} theme={theme} />
        </div>

        <div className={styles.sidebar}>
          <SkeletRect className={styles.sidebarItem1} theme={theme} />
          <SkeletRect className={styles.sidebarItem2} theme={theme} />
          <SkeletRect className={styles.sidebarItem3} theme={theme} />
          <SkeletRect className={styles.sidebarItem4} theme={theme} />
          <SkeletRect className={styles.sidebarItem5} theme={theme} />
        </div>
      </div>

      <div className={styles.products}>
        {products.map((_, index) => (
          <SkeletCrossaleProduct theme={theme} key={index} />
        ))}
      </div>

      <SkeletWave className={styles.wave} theme={theme} />
    </div>
  );
};

export default SkeletPage;
